import { VERSION } from '@/utils/constants'
import getCustomPagesScenesConfigV3 from '@/utils/getCustomePages/getCustomPagesScenesConfig'
import { useClientScreenNames } from '@mercadoni/mimic/dist/cjs/ClientScreenName'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { useMemo } from 'react'

const useHeaderDataConfig = (clientModel: ClientModel) => {
  const { locale: clientLocale, clientId, customPages } = clientModel

  const customPagesConfig = useMemo(
    () => getCustomPagesScenesConfigV3({ customPages }),
    [customPages]
  )

  const { screenNames, loading } = useClientScreenNames({
    clientId,
    customPagesConfig,
    clientLocale,
  })

  return useMemo(
    () => ({
      screenNames,
      loading,
      version: VERSION,
    }),
    [screenNames, loading]
  )
}

export { useHeaderDataConfig }
